<template>
  <div class="tabsContent1">

    <div class="main-con">
      <div class="time-con">
        <div class="type-btn " :class="sletime=='3'?'active-time-btn':''" @click="changesle('3')">
          时
        </div>
        <div class="type-btn" :class="sletime=='2'?'active-time-btn':''" @click="changesle('2')">
          日
        </div>
        <div class="type-btn" :class="sletime=='1'?'active-time-btn':''" @click="changesle('1')">
          月
        </div>
        <el-date-picker
          v-if="sletime==1"
          v-model="time"
          value-format="yyyy"
          size="large"
          style="width: 200px;"
          type="year"
        >
        </el-date-picker>
        <el-date-picker
          v-model="time"
          v-if="sletime==2"
          style="width: 200px;"
          size="large"
          value-format="yyyy-MM"
          type="month"
        >
        </el-date-picker>
        <el-date-picker
          v-model="time"
          style="width: 200px;"
          size="large"
          v-if="sletime==3"
          value-format="yyyy-MM-dd"
          type="date"
        >
        </el-date-picker>
<!--        <div class="btn-item" @click="getmaintabledata">-->
<!--          查询-->
<!--        </div>-->
      </div>
      <div class="table-con">
        <table class="table-font" cellspacing="0">
          <tr class="fir-tr"><td v-for="item in titledata">{{item}}</td></tr>
          <tr v-for="item in tabledata"><td v-for="(pum) in item">{{pum}}</td></tr>
        </table>
      </div>
      <div class="select-check">
        <el-checkbox-group v-model="checkList">
          <el-checkbox :label=item.param :key="item.param"  v-for="(item , index) in itemList" @change="checkitem(item,index)">
            {{item.description}}
          </el-checkbox>

        </el-checkbox-group>


      </div>
      <div class="all-check">
        <div class="cavItem" v-for="item in activecon" :id="'cav'+item">

        </div>
      </div>

    </div>


  </div>
</template>

<script>
import Axios from "@/utils/Axios";
import Vue from "vue";
import qs from "qs";
export default {
  name: "tabsContent1",
  props: {

    }
    ,
  data() {
    return {
      titledata:[],
      tabledata:[],
      sletime:"3",
      time:"",
      partype:"Hour",
      year:"",
      month:"",
      hour:"",
      checkList:[],
      activecon:[0],
    };

  },
  mounted() {

    let that=this
    this.getnowtime()
    this.getmaintabledata()
  },
  methods: {
    checkitem(item,index){
      this.activecon=[]

      for(let i=0;i<this.checkList.length;i++){
        this.activecon.push(i)

        this.getcavdata( i,this.checkList[i].split(","))
      }
    },
    changesle(data){
      this.sletime=data
      let type
      if(data=='1'){
        type='Month'
        this.time=this.year
      }else if(data=='2'){
        type='Day'
        this.time=this.month
      }else if(data=='3'){
        type='Hour'
        this.time=this.hour
      }

      this.partype=type

      this.getmaintabledata()
    },
    getnowtime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒
      var MS = now.getMilliseconds(); //获取毫秒
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      if (MS < 100) MS = "0" + MS;
      var time = "";
      time =
        year + "-" + month + "-" + date ;

      this.year=year
      this.month=year + "-" + month
      this.hour=time
      this.time=time

    },
    getcavdata(index,params){

      let that = this;
      let param = {};
      param.method="post";
      if(this.sletime=='3'){
        param.url="/analogData/hourFreezeDataInfoV2";
      }else   if(this.sletime=='2'){
        param.url="/analogData/dayFreezeDataInfoV2";
      }else   if(this.sletime=='1'){
        param.url="/analogData/monthFreezeDataInfoV2";
      }

      param.data=qs.stringify({
        "monitorSiteId":sessionStorage.getItem("saveid"),
        "params":params,
        "searchDate":this.time

      })
      Axios.ajax(param).then((res)=>{

        this.cavdata=[]
        let levlist=[]
        if(res.resultCode=='0'){
          this.cavtitle=res.data.freezeDatas[0]
          for(let i=1;i<res.data.freezeDatas.length;i++){
            this.cavdata.push(res.data.freezeDatas[i])
            levlist.push(res.data.checkSafeDatas[i])
          }

          this.drewcav(this.cavtitle,this.cavdata,index,levlist)
        }else{

        }

      })
    },
    drewcav(title,data,index,levlist){



      let xdata=[]
      let series=[]
      let legend=[]
      let colorlist=[['rgba(255, 255, 0,1)'],['rgba(20, 255, 20,1)'],['rgba(247, 20, 20,1)'],['#85f67a', ''],['#85f67a', ''],['#85f67a', ''],['rgba(255, 200, 0,1)'],['rgba(20, 200, 20,1)'],['rgba(200, 20, 20,1)']]
      for(let i=1;i<title.length;i++){
        series.push(
          {
            name: title[i],
            type: 'bar',
            barWidth: '10px',
            itemStyle: {
              normal: {
                color:function(params){
                  let color=""

                  if(title[i]=='电气火灾' || title[i]=='电气老化'){

                    if(levlist.length!=0){

                      if(levlist[(params.dataIndex)][1]=='1'){
                        color="rgba(20, 255, 20,1)"
                      }else if(levlist[(params.dataIndex)][1]=='2'){
                        color="rgba(255, 255, 0,1)"
                      }else if(levlist[(params.dataIndex)][1]=='3'){
                        color="rgba(255, 153, 0,1)"
                      }else if(levlist[(params.dataIndex)][1]=='4'){
                        color="rgba(247, 20, 20,1)"
                      }
                    }else{

                      color="rgba(20, 255, 20,1)"
                    }

                  }else  if(title[i].indexOf('A相') != -1){
                    color='rgb(0,128,0)'
                  }else if(title[i].indexOf('B相') != -1){
                    color='rgb(255,165,0)'
                  }else if(title[i].indexOf('C相') != -1){
                    color='rgb(255,0,0)'
                  }else{
                    color=colorlist[i-1][0]
                  }
                  return color
                },
                barBorderRadius: 11,
              }
            },
            data: []
          },
        )
        legend.push(title[i])
      }
      for(let i=0;i<data.length;i++){

        let arr=this.time+''
        if(arr.length==4){
          xdata.push(data[i][0].substring(0,7))
        }else{
          xdata.push(data[i][0])
        }


        for(let j=1;j<data[i].length;j++){

          series[j-1].data.push(data[i][j])
        }
      }

      let myChart =this.$echarts.init(document.getElementById('cav'+index));
      myChart.clear()
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          data:legend
        },

        grid: {
          right: '2%',
          bottom: '24px',
          left: '2%',
          top: '20px',
          containLabel: true
        },
        "dataZoom": [{
          "show": true,
          "height": 20,
          "xAxisIndex": [
            0
          ],
          bottom:'0%',
          "start": 10,
          "end": 90,
          handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
          handleSize: '110%',
          handleStyle:{
            color:"#d3dee5",

          },
          textStyle:{
            color:"#000"},
          borderColor:"#90979c"
        }, {
          "type": "inside",
          "show": true,
          "height": 20,
          "start": 1,
          "end": 35
        }],
        xAxis: [{
          type: 'category',
          data: xdata,
          axisLine: {
            lineStyle: {
              color: '#0B4CA9'
            }
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#000",
              fontSize: 12,
            },
            //interval:0,
            //rotate:30
          },
        }],
        yAxis: [{
          type: 'value',
          nameTextStyle: {
            color: '#000'
          },
          position: 'left',
          axisLine: {
            lineStyle: {
              color: '#0B4CA9'
            }
          },
          splitLine: {
            show:false,
            lineStyle: {
              color: "#0B4CA9",
            }

          },
          axisLabel: {
            color: '#000',
            fontSize: 12,
          }
        }],
        series: series
      };
      myChart.setOption(option,true);

      window.onresize = myChart.resize;
    },
    getmaintabledata(){
      let that = this;
      let param = {};
      param.method="post";
      if(this.sletime=='3'){
        param.url="/analogData/hourFreezeDataInfoV2";
      }else   if(this.sletime=='2'){
        param.url="/analogData/dayFreezeDataInfoV2";
      }else   if(this.sletime=='1'){
        param.url="/analogData/monthFreezeDataInfoV2";
      }

      param.data=qs.stringify({
        "monitorSiteId":sessionStorage.getItem("saveid"),
        "params":"",
        "searchDate":this.time

      })
      Axios.ajax(param).then((res)=>{

        this.tabledata=[]
        if(res.resultCode=='0'){
          this.titledata=res.data.freezeDatas[0]
          for(let i=1;i<res.data.freezeDatas.length;i++){
            this.tabledata.push(res.data.freezeDatas[i])
          }
          this.activecon=[0]
          this.getparam()
        }else{

        }

      })
    },
    getparam() {
      let that = this;
      let param = {};
      param.method="post";
      param.url="/analogData/getParameterInfo";
      param.data=qs.stringify({
        "monitorSiteId":sessionStorage.getItem("saveid"),
        "type":this.partype,

      })
      Axios.ajax(param).then((res)=>{

        if(res.resultCode=='0'){
          this.itemList=res.data
          for(let i = 0;i<res.data.length;i++){
            this.itemList[i].param=res.data[i].parameter.toString()
          }

          this.checkList=[this.itemList[0].param]

          this.getcavdata(0,this.itemList[0].parameter)
        }else{

        }

      })
    },
  },
  watch: {
    time(){
      this.getmaintabledata()
    }
  },
  destroyed() {

  },
  components: {

  }
};
</script>
<style lang="less" rel="stylesheet/less" scoped>
.tabsContent1{
  height: 100%;

  padding:10px;
  .main-con{
    background-color: #fff;
    height: calc(100% - 110px);
    width: calc(100% - 20px);
    padding:10px;
    margin-top: 10px;
    .table-font{
      width: 100%;
      td{
        text-align: center;
        height: 44px;
        border: 1px solid #ebeef5;
        font-size: 14px;
      }
      tr:nth-child(odd){
        background-color: rgb(245, 245, 245);
      }
      .fir-tr{
        background-color: rgb(245, 245, 245);
        color: rgb(0, 0, 0);
        font-weight: 500;


      }
    }
    .time-con{
      float: right;
      position: relative;
      top: -36px;
    }
    .time-type{
      margin-bottom:14px;

    }
    .type-btn{
      display: inline-block;
      width: 74px;
      height: 30px;
      text-align: center;

      line-height: 30px;
      margin-right: 20px;
      border-radius: 4px;
      cursor: pointer;
      border: 1px solid #5780fa;
      color: #5780fa;
    }
    .active-time-btn{
      background-color: #5780fa;
      color: #fff;
    }
    .btn-item{
      display: inline-block;
      width: 80px;
      height: 40px;
      background: #2A62FF;
      border-radius: 4px;
      line-height: 40px;
      text-align: center;
      color: #fff;
      font-size: 14px;
      margin-left: 48px;
      cursor: pointer;
    }
  }
  .table-con{

    height: 400px;
    overflow: auto;
    width: 100%;
    margin: 0 auto;
    margin-top: 10px;
  }
  .select-check{
    position: relative;
    margin-top: 40px;

  }
  .cavItem{
    width: 1400px;
    margin: 0 auto;
    height: 200px;
    margin-bottom: 16px;
    margin-top: 20px;
  }
  .all-check{
    min-height: 600px;
    overflow: auto;
    padding-bottom: 20px;
  }
}
</style>
<style lang="less">
#app .tabsContent1 .search-blank {
  .el-tabs--border-card > .el-tabs__content {
    padding: 0;
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 175px;
  }
  .el-input__inner {
    width: 175px;
    height: 30px;
    line-height: 28px;
  }
  .el-input__icon {
    line-height: 28px;
  }
}
#app .tabsContent1 .el-pagination.is-background .el-pager li:not(.disabled).active{
  color: #fff;
}
#app .tabsContent1 .el-select-dropdown__wrap{
  max-heigt:300px;
}
</style>
